import { render, staticRenderFns } from "./QuoteInfo.vue?vue&type=template&id=77fc4e95&scoped=true"
import script from "./QuoteInfo.vue?vue&type=script&lang=js"
export * from "./QuoteInfo.vue?vue&type=script&lang=js"
import style0 from "./QuoteInfo.vue?vue&type=style&index=0&id=77fc4e95&prod&lang=scss"
import style1 from "./QuoteInfo.vue?vue&type=style&index=1&id=77fc4e95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fc4e95",
  null
  
)

export default component.exports